import React from "react";

const DefaultIcon = ({
  fill = "#999999",
  height = 24,
  width = 24,
  title = "?",
}) => {
  // Get the first character of the title
  const initial = title && title[0] ? title[0].toUpperCase() : "?";

  // Convert hex to rgba with opacity
  const hexToRgba = (hex, opacity = 0.15) => {
    try {
      // Handle if fill is already rgba
      if (hex.startsWith("rgba")) {
        return hex.replace(/[\d.]+\)/, `${opacity})`);
      }
      // Remove # if present
      const cleanHex = hex.replace("#", "");
      const r = parseInt(cleanHex.slice(0, 2), 16);
      const g = parseInt(cleanHex.slice(2, 4), 16);
      const b = parseInt(cleanHex.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    } catch (e) {
      return `rgba(153, 153, 153, ${opacity})`; // fallback gray
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: height || 24,
        width: width || 24,
        minHeight: height || 24,
        minWidth: width || 24,
        borderRadius: "50%",
        backgroundColor: hexToRgba(fill, 0.15),
        color: fill || "#999999",
        fontSize: typeof height === "number" ? height * 0.6 : 14,
        fontWeight: 600,
        fontFamily: "Poppins",
        userSelect: "none",
        border: `1px solid ${hexToRgba(fill, 0.3)}`,
      }}
    >
      {initial}
    </div>
  );
};

export default DefaultIcon;
